import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { DropDownOptions, ExtendedKeycloakUser, StoreDropdowns } from 'src/app/shared/models/app-models';

@Component({
  selector: 'app-purchasing-executive-assignment-form-dialog',
  templateUrl: './purchasing-executive-assignment-form-dialog.component.html',
  styleUrls: ['./purchasing-executive-assignment-form-dialog.component.scss']
})
export class PurchasingExecutiveAssignmentFormDialogComponent {
  peForm: FormGroup = new FormGroup({
    purchasingExecutive: new FormControl(''),
    itemNumbers: new FormControl([]),
    originalTaskOwner: new FormControl('')
  });
  action: string = '';
  peArray: string[] = [];
  itemArray: number[] = [];
  itemIdMappings: Map<number, DropDownOptions> = new Map<number,  DropDownOptions>()
  KCUserList: ExtendedKeycloakUser[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private dialogRef: MatDialogRef<PurchasingExecutiveAssignmentFormDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private store: Store<{
    dp: StoreDropdowns
  }>) {

    if (data.peArray) this.peArray = data.peArray
    if (data.itemArray) this.itemArray = data.itemArray
    if (data.itemIdMappings) this.itemIdMappings = data.itemIdMappings
    if (data.record && this.peArray.length > 0) {
      let originalRecord = structuredClone(data.record)
      this.peForm.setValue({
        purchasingExecutive: this.peArray[0],
        itemNumbers: [originalRecord.itemNumber],
        originalTaskOwner: originalRecord.purchasingExecutive
      })
    }
    if (data.action) this.action = data.action
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.KCUserList = dp.UserList as ExtendedKeycloakUser[];
      });
  }
  displayFrontendItemDescription(itemId: number) {
    return this.itemIdMappings.get(itemId)!.value
  }
  getPurchasingExecutiveFormControl() {
    return this.peForm.controls['purchasingExecutive'] as FormControl
  }
  getItemListFormControl() {
    return this.peForm.controls['itemNumbers'] as FormControl
  }
  getNameOfUser(username: string) {
    return this.KCUserList.find((user) => user.username == username)?.value ?? username;
  }
  onSubmit(
  ) {
    if (!this.peForm.controls['itemNumbers'].errors && !this.peForm.controls['purchasingExecutive'].errors) {
      const results = this.peForm.getRawValue()
      this.dialogRef.close(results)
    }
    else this.dialogRef.close()
  }
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }
}
